export class UserSettings {
  filtersPanelPinned: boolean;
  workItemsPanelPinned: boolean;
  setupProcessCountryFilter: string[];

  constructor() {
    this.filtersPanelPinned = true;
    this.workItemsPanelPinned = true;
    this.setupProcessCountryFilter = [];
  }
}
